<!-- 特价单 -->
<template>
  <div class="my-mad-department p5 m5 bw br5">
    <div class="header-style mb5">
      特价单
    </div>
<!--    <search-vue ref="searchVue" :columns="tableSet.columns" :valueSet="valueSet" :onlyKey="'specialOffer'"></search-vue>-->
    <div class="fix">
      <q-input class="w180 l mr10" outlined placeholder="输入特价单号查询" v-model="query.VBELN" dense square clearable>
      </q-input>
      <q-btn size='9px' class="l mr10" color="primary" icon="fas fa-search" @click="search"></q-btn>
    </div>
    <div>
      <base-table v-if="!tableSet.loading" @tool_click="tool_click" :tableSet="tableSet" @changeRowsPage="changeRowsPage" @changePage="changePage" @updateSelected="updateSelected"></base-table>
      <q-skeleton :height="tableSet.height" v-if="tableSet.loading" />
    </div>
    <div>
      <q-toolbar class="text-grey">
                <q-tabs v-model="tab" shrink stretch narrow-indicator active-color="primary" @update:model-value="changeTab">
                    <q-tab name="xmxx" label="项目信息" />
                    <q-tab name="jetjxx" label="金额条件信息" />
                </q-tabs>
                <q-space />
            </q-toolbar>
            <span v-if="tab == 'jetjxx'">
              <base-table v-if="!priceTableSet.loading" @tool_click="tool_click" :tableSet="priceTableSet" @changeRowsPage="changeRowsPage" @changePage="changePage" @updateSelected="updateSelected"></base-table>
              <q-skeleton :height="priceTableSet.height" v-if="priceTableSet.loading" />
            </span>
            <span v-if="tab == 'xmxx'">
              <base-table v-if="!entryTableSet.loading && !tableSet.loading" @tool_click="tool_click" :tableSet="entryTableSet" @changeRowsPage="changeRowsPage" @changePage="changePage" @updateSelected="updateSelected"></base-table>
              <q-skeleton :height="entryTableSet.height" v-if="entryTableSet.loading || tableSet.loading" />
            </span>
    </div>
  </div>
</template>

<script>
import {onMounted, ref,watch,computed} from "vue";
import API from '@/apis/index';
import BaseTable from '@/components/pieces/tables/default-table.vue';
import {useStore} from "vuex";
import {tableHeight} from "@/tools/lines.js";
import {getRandomString} from '@/tools/utils.js'
import {useRouter} from "vue-router";
import searchVue from '@/components/pieces/search/search.vue';
import {isNotEmpty} from "@/tools/utils";
export default {
  name: "specialOffer",
  components:{
    BaseTable
  },
  setup(){
    let store = useStore();
    let tab = ref('xmxx');
    const router = useRouter();
    let valueSet = ref({});
    let formData = ref({
      keys: '',
      Fpp:'',
      Fdhh:'',
      Fxj:'',
      Fmx:'',
    });
    let tableSet =store.getters["specialOffer/getTable"];
    let entryTableSet =store.getters["specialOffer/getEntryTable"];
    let priceTableSet =store.getters["specialOffer/getPriceTable"];
    let query = ref({
      VBELN:''
    })
    let changeRowsPage = (value)=>{
      localStorage.setItem("pageSize", value);
      tableSet.pagination.rowsPerPage = value;
      getTableData();
    }
    let changePage = (value)=>{
      tableSet.pagination.page = value;
      getTableData();
    }
    let updateSelected = (data)=>{
      store.dispatch('specialOffer/getSoEntryList')
    }
    let changeTab = (value)=>{
      store.commit("specialOffer/setTab",tab.value);
      store.dispatch("specialOffer/getSoEntryList");
    }
    /**
     * 刷新表格高度
     */
    function refreshTableHeight() {
      store.commit("specialOffer/setTableHeight", tableHeight());
    }
    function getParams(){
      let params={
        pagination: {
          rowsPerPage: tableSet.pagination.rowsPerPage,
          page: tableSet.pagination.page
        },
      };
      if(isNotEmpty(query.value.VBELN)){
        params.multi_query = {
          keys:query.value.VBELN.trim(),
          fields:["VBELN"]
        };
      }
      return params
    }
    function search(){
      tableSet.pagination.page = 1;
      getTableData();
    }
    function getTableData(){
      let params = getParams();
      store.dispatch("specialOffer/getList",params)
    }
    function init(){
      store.commit("specialOffer/setResetFun",getTableData);
      getTableData();
    }
    onMounted(()=>{
      init();
      refreshTableHeight();
      store.commit("specialOffer/setTab",tab.value);
      window.onresize = () => {
        return (() => {
          refreshTableHeight();
        })();
      };
    });
    function tool_click(type){
      if(type == 'createEoder'){
        gotoEoder();
      }
      if(type == 'clearState'){
        clearStateFun();
      }
    }
    let tabs = computed(()=>store.getters['page/getStickyTabs']);
    let clearStateFun = ()=>{
      if(tableSet.selected.length !=1){
        store.dispatch("response/set-api-response", {errorMessage:'请勾选一行特价单进行操作!'}, { root: true });
        return;
      }
      store.dispatch("specialOffer/clearState",tableSet.selected[0].VBELN);
    }
    function gotoEoder(){
      if(tableSet.selected.length !=1){
        store.dispatch("response/set-api-response", {errorMessage:'请勾选一行特价单进行操作!'}, { root: true });
        return;
      }
      if(tableSet.selected[0]['CREATE_CODE'] == true){
        store.dispatch("response/set-api-response", {errorMessage:'该特价单已生成采购订单!'}, { root: true });
        return;
      }
      let hasPage = tabs.value.some((item)=>{
        return item.name == 'eorderDetails';
      });
      if(hasPage){
        store.dispatch("response/set-api-response", {errorMessage:'生成电子订单页面已打开，请关闭后打开新的单据!'}, { root: true });
        return
      }
      router.push({
        name: "eorderDetails",
        params:{id:tableSet.selected[0].VBELN}
      });
    }
    return{
      formData,
      search,
      tableSet,
      tool_click,
      tab,
      valueSet,
      changeRowsPage,
      changePage,
      updateSelected,
      entryTableSet,
      query,priceTableSet,
      changeTab
    }
  },
}
</script>




